import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import { NAV_SECTION_BY_PATH } from "./sidebarConfig";

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

const ROUTE_LABELS: Record<string, string> = {
  "/": "Dashboard",
  "/developers": "Developers",
  "/merge-requests": "Merge Requests",
  "/projects": "Projects",
  "/quality": "Quality",
  "/operations": "Operations",
  "/system-health": "System Health",
  "/development": "Development",
  "/settings": "Settings",
};

export function useBreadcrumbs(overrideDetailLabel?: string): BreadcrumbItem[] {
  const { pathname } = useLocation();
  const params = useParams();
  const detailLabel = overrideDetailLabel;

  return useMemo(() => {
    if (pathname === "/") {
      return [{ label: "Dashboard" }];
    }

    const crumbs: BreadcrumbItem[] = [{ label: "Dashboard", path: "/" }];
    const segments = pathname.split("/").filter(Boolean);
    const baseRoute = segments.length > 0 ? `/${segments[0]}` : pathname;
    const sectionLabel = NAV_SECTION_BY_PATH[baseRoute];

    if (sectionLabel) {
      crumbs.push({ label: sectionLabel });
    }

    if (params.id && detailLabel) {
      const parentLabel = ROUTE_LABELS[baseRoute];
      if (parentLabel) {
        crumbs.push({ label: parentLabel, path: baseRoute });
      }
      crumbs.push({ label: detailLabel });
      return crumbs;
    }

    const pageLabel = ROUTE_LABELS[pathname] ?? ROUTE_LABELS[baseRoute];
    if (pageLabel) {
      crumbs.push({ label: pageLabel });
    }

    return crumbs;
  }, [pathname, params.id, detailLabel]);
}
